export const searchFilter = (arr, term) => {
  return arr.filter((obj) =>
    Object.keys(obj).some((key) => obj[key].toLowerCase().includes(term.toLowerCase()))
  )
}


const HTTP_PATTERN = /((?:https?:\/\/|www\.)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)/i

const WWW_URL_PATTERN = /^www\./i

export const validateUrl = (link) => {
  if (WWW_URL_PATTERN.test(link)) {
    return `http://${link}`
  } else if (HTTP_PATTERN.test(link)) {
    return link
  } else {
    return `http://${link}`
  }
}

const PHONE_PATTERN = /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/

export const callifyHtml = (str) => {
  return str.split(' ').map(str =>
    PHONE_PATTERN.test(str) ? ` <a href="tel:${str}" rel="noreferrer noopener" target="_blank">${str}</a>` : str
  ).join(' ')
}
